import _ from 'lodash';
import { DATA_FIELDS as Fields, COMPONENTS } from '../constants/constants';

export const hasWholeValue = value => {
  if (_.isNil(value)) {
    return false;
  }
  if (typeof value === 'string' && value.length === 0) {
    return false;
  }

  const parseValue = parseFloat(value);
  if (isNaN(parseValue)) {
    return false;
  } else {
    return parseValue > 0;
  }
};

/**
 * Converts recipe data into a my plate data
 */
export const convertToMyPlate = data => {
  let output = {};

  output.hasDairy = hasWholeValue(data[Fields.Milk]);

  output.hasGrain =
    hasWholeValue(data[Fields.EnrichedGrain]) ||
    hasWholeValue(data[Fields.WholeGrain]);

  output.hasProtein = hasWholeValue(data[Fields.MeatAlt]);

  output.hasVegetable =
    hasWholeValue(data[Fields.DarkGreenVeg]) ||
    hasWholeValue(data[Fields.LegumesVeg]) ||
    hasWholeValue(data[Fields.OtherVeg]) ||
    hasWholeValue(data[Fields.RedOrangeVeg]) ||
    hasWholeValue(data[Fields.StarchyVeg]);

  output.hasFruit = hasWholeValue(data[Fields.Fruit]);
  return output;
};

/**
 * retrieves the appropriate measure for a component
 */
export const getComponentMeasure = component => {
  const measure =
    component === COMPONENTS.DarkGreenVeg ||
    component === COMPONENTS.RedOrangeVeg ||
    component === COMPONENTS.StarchyVeg ||
    component === COMPONENTS.Milk ||
    component === COMPONENTS.Fruit ||
    component === COMPONENTS.LegumesVeg ||
    component === COMPONENTS.OtherVeg
      ? 'cups'
      : 'oz eq';
  return measure;
};



// WEBPACK FOOTER //
// ./src/common/Components/NutritionalHover/helpers/helpers.js